import script from "./ClientDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ClientDetail.vue?vue&type=style&index=0&id=400f488c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-400f488c"]])

export default __exports__